import React, { useState, useRef, useEffect } from "react";

///style MUI
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Tooltip from "@mui/material/Tooltip";
///style bootstrap
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
///icon
import { TbDrone } from "react-icons/tb";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import FolderOffIcon from "@mui/icons-material/FolderOff";

import TaskIcon from "@mui/icons-material/Task";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import AssignmentIcon from "@mui/icons-material/Assignment";
import NoteAddIcon from "@mui/icons-material/NoteAdd";

export default function Drone_Status_Regulator(props) {
  const [main_status, setmain_status] = useState([]);
  useEffect(() => {
    setmain_status([props.status]);
  }, [props.status]);

  // const [main_status, setmain_status] = useState(['ชำระพิจารณาคำขอ']);

  const [modal_state, setmodal_state] = useState();
  const handleChange_modal = () => {
    setmodal_state(true);
  };
  const handleClose_modal = () => {
    setmodal_state(false);
  };

  const [id, setid] = useState(0);
  useEffect(() => {
    setid(props.id);
  }, [props.id]);

  return (
    <>
      <div>
        {main_status[0] === "อนุมัติ" || main_status[0] === "ไม่อนุมัติ" ? (
          <>
            {main_status[0] === "อนุมัติ" ? (
              <div className="center">
                <Tooltip
                  title={
                    <span style={{ fontSize: "16px", fontFamily: "Kanit" }}>
                      อนุมัติ
                    </span>
                  }
                  placement="top"
                >
                  <FactCheckIcon
                    style={{
                      width: "32px",
                      height: "32px",
                      color: "green",
                      opacity: 0.9,
                    }}
                  />
                </Tooltip>
              </div>
            ) : (
              <div className="center">
                <Tooltip
                  title={
                    <span style={{ fontSize: "16px", fontFamily: "Kanit" }}>
                      ไม่อนุมัติ
                    </span>
                  }
                  placement="top"
                >
                  <FolderOffIcon
                    style={{
                      width: "32px",
                      height: "32px",
                      color: "red",
                      opacity: 0.75,
                    }}
                  />
                </Tooltip>
              </div>
            )}
          </>
        ) : (
          <div>
            <TbDrone
              onClick={handleChange_modal}
              className="icon-weather"
              style={{ width: "30px", height: "30px" }}
            />
          </div>
        )}
      </div>
      <Modal show={modal_state} onHide={handleClose_modal} centered>
        <Modal.Header closeButton>
          <Modal.Title>สถานะการทำรายการ</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Modal_Status status={main_status} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose_modal}>
            ปิด
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
const Modal_Status = (props) => {
  const [activekey, setActiveKey] = useState(1);
  const checklist = [
    ["เอกสารครบถ้วน", "ร่างเอกสาร", "ยื่นคำขอลงทะเบียน", "ตรวจสอบเอกสาร", "รอแก้ไข"],
    ["ชำระพิจารณาคำขอ"],
    ["ตรวจสอบการชำระเงิน"],
    ["อยู่ระหว่างการพิจารณา"],
    ["อนุมัติ", "ไม่อนุมัติ"],
  ];
  const [data_list_display, setdata_list_display] = useState([]);
  function process_checklist(status) {
    let data_list = [];
    switch (status[0]) {
      case "ร่างเอกสาร":
           data_list = [
            { Label: "ร่างเอกสาร", completed: false, active: true, error: false, icon: 1 },
            { Label: "รออนุมัติเอกสาร", completed: false, active: false, error: false, icon: 2 },//pending
            { Label: "ตรวจสอบการชำระเงิน", completed: false, active: false, error: false, icon: 3 },
            { Label: "รอการพิจารณา", completed: false, active: false, error: false, icon: 4 },//pending
            { Label: "รออนุมัติ", completed: false, active: false, error: false, icon: 5 }
          ]
          return data_list;
      case "ยื่นคำขอลงทะเบียน":
        data_list = [
          { Label: "ยื่นคำขอลงทะเบียน", completed: true, active: false, error: false, icon: 1 },
          { Label: "รอตรวจสอบเอกสาร", completed: false, active: true, error: false, icon: 2 },//pending
          { Label: "ตรวจสอบการชำระเงิน", completed: false, active: false, error: false, icon: 3 },
          { Label: "รอการพิจารณา", completed: false, active: false, error: false, icon: 4 },//pending
          { Label: "รออนุมัติ", completed: false, active: false, error: false, icon: 5 }
        ]
        return data_list;
        case "รอแก้ไข":
          data_list = [
            { Label: "ยื่นคำขอลงทะเบียน", completed: true, active: false, error: false, icon: 1 },
            { Label: "รอการแก้ไข", completed: false, active: true, error: false, icon: 2 },//pending
            { Label: "ตรวจสอบการชำระเงิน", completed: false, active: false, error: false, icon: 3 },
            { Label: "รอการพิจารณา", completed: false, active: false, error: false, icon: 4 },//pending
            { Label: "รออนุมัติ", completed: false, active: false, error: false, icon: 5 }
          ]
          return data_list;
        case "ตรวจสอบเอกสาร":
        data_list = [
          { Label: "ยื่นคำขอลงทะเบียน", completed: true, active: false, error: false, icon: 1 },
          { Label: "ตรวจสอบเอกสาร", completed: false, active: true, error: false, icon: 2 },//pending
          { Label: "รอการชำระ", completed: false, active: false, error: false, icon: 3 },
          { Label: "รอการพิจารณา", completed: false, active: false, error: false, icon: 4 },//pending
          { Label: "รออนุมัติ", completed: false, active: false, error: false, icon: 5 }
        ]
        return data_list;
        case "ชำระค่าพิจารณาคำขอ":
        data_list = [
          { Label: "เอกสารครบถ้วน", completed: true, active: false, error: false, icon: 1 },
          { Label: "อนุมัติเอกสาร", completed: true, active: false, error: false, icon: 2 },//pending
          { Label: "ชำระค่าพิจารณาคำขอ", completed: false, active: true, error: false, icon: 3 },
          { Label: "รอการพิจารณา", completed: false, active: false, error: false, icon: 4 },//pending
          { Label: "รออนุมัติ", completed: false, active: false, error: false, icon: 5 }
        ]
        return data_list;
        case "ตรวจสอบการชำระเงิน":
        data_list = [
          { Label: "เอกสารครบถ้วน", completed: true, active: false, error: false, icon: 1 },
          { Label: "อนุมัติเอกสาร", completed: true, active: false, error: false, icon: 2 },//pending
          { Label: "ตรวจสอบการชำระเงิน", completed: false, active: true, error: false, icon: 3 },
          { Label: "รอการพิจารณา", completed: false, active: false, error: false, icon: 4 },//pending
          { Label: "รออนุมัติ", completed: false, active: false, error: false, icon: 5 }
        ]
        return data_list;
        case "อยู่ระหว่างการพิจารณา":
        data_list = [
          { Label: "เอกสารครบถ้วน", completed: true, active: false, error: false, icon: 1 },
          { Label: "อนุมัติเอกสาร", completed: true, active: false, error: false, icon: 2 },//pending
          { Label: "ชำระเงินเรียบร้อย", completed: true, active: false, error: false, icon: 3 },
          { Label: "อยู่ระหว่างพิจารณา", completed: false, active: true, error: false, icon: 4 },//pending
          { Label: "รออนุมัติ", completed: false, active: false, error: false, icon: 5 }
        ]
        return data_list;
      default:
        data_list=[]
        return data_list;
    }

   
  }
  function IconStep(props) {
    const { label, active, completed } = props;

    let icon;
    if (completed && !active) {
      icon = (
        <TaskIcon
          style={{
            width: "26px",
            height: "26px",
            color: "green",
            opacity: 0.9,
          }}
        />
      );
    } else if (completed && active) {
      icon = (
        <TaskIcon
          style={{
            width: "26px",
            height: "26px",
            color: "green",
            opacity: 0.9,
          }}
        />
      );
    } else if (!completed && active) {
      icon = (
        <PendingActionsIcon
          style={{
            width: "26px",
            height: "26px",
            color: "orange",
            opacity: 0.9,
          }}
        />
      );
    } else {
      icon = (
        <AssignmentIcon
          style={{ width: "26px", height: "26px", color: "gray", opacity: 0.9 }}
        />
      );
    }

    return icon;
  }
  useEffect(() => {
    let datalist = process_checklist(props.status);
    console.log(props.status);
    console.log(datalist);
    setdata_list_display(datalist);
    
  }, [props.status]);

  return (
    <>
      <Stepper alternativeLabel >
        {data_list_display.map((item) => (
          <Step key={item.Label}>
            <Tooltip
              title={
                <span style={{ fontSize: "16px", fontFamily: "Kanit" }}>
                  {item.Label}
                </span>
              }
              placement="top"
            >
              <StepLabel
                style={{ fontSize: "12px" }}
                StepIconComponent={(props) => (
                  <IconStep label={item.Label} {...item} />
                )}
              >
                {item.Label}
              </StepLabel>
            </Tooltip>
          </Step>
        ))}
      </Stepper>
    </>
  );
};
